import React from "react";
import { EnvelopeIcon, LinkIcon } from "@heroicons/react/24/outline";


const Footer = () => {
  return (
    <footer className="w-full bg-white text-gray-800 border-t border-gray-200 pt-10 pb-8 mt-24 relative overflow-hidden">
      <div className="max-w-6xl mx-auto px-6 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-10 text-sm text-center sm:text-left">
        
        {/* Company Info */}
        <div>
          <h3 className="font-semibold text-gray-800 mb-2">Techverra Internships</h3>
          <h3 className="font-semibold text-gray-800 mb-2">Powered by</h3>
          <p className="text-gray-600 mb-2">
            &copy; {new Date().getFullYear()} TECHVERRA SOLUTIONS PRIVATE LIMITED. All rights reserved.
          </p>
          <div className="flex items-center justify-center sm:justify-start gap-3 mt-2">
            <a
              href="mailto:techverrasolutions@gmail.com"
              className="flex items-center gap-1 text-gray-600 hover:text-purple-600 transition"
              aria-label="Email Techverra"
            >
              <EnvelopeIcon className="w-4 h-4" />
              info@techverra.com
            </a>
            <a
              href="https://www.linkedin.com/company/techverra-solutions/"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-1 text-gray-600 hover:text-purple-600 transition"
              aria-label="LinkedIn"
            >
              <LinkIcon className="w-4 h-4" />
              LinkedIn
            </a>
          </div>
        </div>

        {/* Newsletter */}
        <div>
          <h3 className="font-semibold text-gray-800 mb-2">Stay Updated</h3>
          <p className="text-gray-600 mb-4">Join our newsletter for updates on internships & programs.</p>
          <form
            onSubmit={(e) => {
              e.preventDefault();
              alert("Thank you for subscribing!");
            }}
            className="flex flex-col sm:flex-row gap-2"
          >
            <input
              type="email"
              required
              placeholder="Your email"
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-400"
            />
            <button
              type="submit"
              className="px-4 py-2 bg-purple-600 text-white font-medium rounded-lg hover:bg-purple-700 transition"
            >
              Subscribe
            </button>
          </form>
        </div>

        {/* Legal Links */}
        <div>
          <h3 className="font-semibold text-gray-800 mb-2">Legal</h3>
          <ul className="space-y-2 text-gray-600">
            <li>
              <a href="/internship-policy" className="hover:text-purple-600 transition">Privacy Policy</a>
            </li>
            <li>
              <a href="/internship-policy" className="hover:text-purple-600 transition">Terms & Conditions</a>
            </li>
            <li>
              <a href="/internship-policy" className="hover:text-purple-600 transition">Contact Us</a>
            </li>
          </ul>
        </div>
      </div>

      {/* Glowing Light Pulse */}
      <div
        className="absolute bottom-0 left-1/2 -translate-x-1/2 w-[200px] h-[200px] bg-purple-400 opacity-10 blur-3xl rounded-full pointer-events-none animate-pulse"
        aria-hidden="true"
      />
    </footer>
  );
};

export default Footer;
